// extracted by mini-css-extract-plugin
export default {"root":"TvLh1d6QfEsbCphUcJTP","menuButton":"WJemOovcjm52MlmxLgqY"};